import { getAssetsPath } from "common";
import { hd_applyTint } from "hdcolors";

const loadBuffer = path => fetch(getAssetsPath(path)).then(r => r.arrayBuffer()).then(b => new Uint8Array(b));

const bufferToImage = data => new Promise((resolve, reject) => {
  const img = new Image();
  const url = URL.createObjectURL(new Blob([data], {type: 'image/png'}));
  img.onload = () => {
    URL.revokeObjectURL(url);
    resolve(img);
  };
  img.onerror = () => {
    URL.revokeObjectURL(url);
    reject();
  };
  img.src = url;
});

const itemLib = fetch(getAssetsPath('hditemlib.json')).then(r => r.json());
const itemarc = [];
const itempng = {};
export function hd_itempng(name) {
  if (!name) return null;
  name = name.toLowerCase();
  if (!itempng[name]) {
    itempng[name] = itemLib.then(async lib => {
      const entry = lib[name];
      if (!entry) return null;
      const [index, offset, length] = entry;
      if (!itemarc[index]) {
        itemarc[index] = loadBuffer(`hditems${index}.pngx`);
      }
      const buf = await itemarc[index];
      return bufferToImage(buf.subarray(offset, offset + length));
    });
  }
  return itempng[name];
}

export async function hd_makeBitmap(png, tint, framew, frameList, name) {
  if (!png) return null;

  const frames = [];
  if (framew) {
    const count = png.width / framew;
    if (!frameList) {
      frameList = [...Array(count)].map((_, i) => i);
    } else {
      frameList = frameList.filter(i => i >= 0 && i < count);
    }
    for (const i of frameList) {
      frames[i] = {x: i * framew, y: 0, width: framew, height: png.height};
    }
  } else {
    frames.push({x: 0, y: 0, width: png.width, height: png.height});
  }

  if (!tint || tint < 21 || tint === 21 * 9) {
    return {bitmap: png, frames};
  }

  const twidth = frames.reduce((sum, f) => sum + f.width, 0);

  const canvas = document.createElement('canvas');
  canvas.width = twidth;
  canvas.height = png.height;
  const ctx = canvas.getContext('2d');

  let pos = 0;
  frames.forEach(f => {
    ctx.drawImage(png, f.x, f.y, f.width, f.height, pos, 0, f.width, f.height);
    const data = ctx.getImageData(pos, 0, f.width, f.height);
    const result = hd_applyTint(data.data, data.width * data.height, tint, name);
    data.data.set(result, 0);
    ctx.putImageData(data, pos, 0);
    f.x = pos;
    pos += f.width;
  });

  return {bitmap: canvas, frames};
}

export async function hd_createIcon(name, tint) {
  const dc6 = await hd_itempng(name);
  return hd_makeBitmap(dc6, tint, null, null, name);
}

const imageCache = {};
export function hd_getCommonImage(name) {
  if (imageCache[name]) return imageCache[name];
  return imageCache[name] = hd_createIcon(name);
}

export function hd_clearCache() {
  itemarc.length = 0;
  for (const id in imageCache) {
    delete imageCache[id];
  }
  for (const id in itempng) {
    delete itempng[id];
  }
}
